import React from 'react';
import { Lock, Send, Code } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FeaturesSection = () => {
  const features = [
    {
      icon: Lock,
      title: 'Highest level of jurisdictional privacy protection',
      description: 'Vaulted Mails is based under Swiss jurisdiction, ensuring your data is protected by globally recognized strict privacy laws and legal safeguards.',
      bgColor: 'bg-[#032a60]/10',
      iconColor: 'text-[#032a60]',
    },
    {
      icon: Send,
      title: 'Smooth migration and data transfer system',
      description: 'With our Express Transfer feature, you can easily switch from any email provider to Vaulted Mails. Move all emails, folders, contacts, and calendar data with automated forwarding support.',
      bgColor: 'bg-[#d28f28]/10',
      iconColor: 'text-[#d28f28]',
    },
    {
      icon: Code,
      title: 'Fully auditable transparent security system',
      description: 'Our infrastructure is built on open-source technologies and continuously evaluated through independent security audits. This ensures complete trust, transparency, and accountability.',
      bgColor: 'bg-[#032a60]/10',
      iconColor: 'text-[#032a60]',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white overflow-hidden group"
            >
              <CardContent className="p-8 space-y-6">
                <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <feature.icon className={`h-8 w-8 ${feature.iconColor}`} strokeWidth={2} />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                  {feature.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Decorative bottom accent */}
                <div className="pt-4">
                  <div className={`h-1 w-0 group-hover:w-full ${feature.iconColor === 'text-[#032a60]' ? 'bg-[#032a60]' : 'bg-[#d28f28]'} transition-all duration-500`}></div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;